//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
    name: 'SpinnerCircle',
    props: {
        color: {
            type: String,
            required: false,
            default: '#ffffff',
        },
        size: {
            type: String,
            required: false,
            default: '24',
        },
    },
};

export default script;
